module.exports = require("lodash/zipObject");